// // src/firebase.js
// import { initializeApp } from 'firebase/app';
// import { getFirestore } from 'firebase/firestore';
// import { getAuth } from 'firebase/auth';
// import { getStorage } from 'firebase/storage';
// // --- Import getFunctions ---
// import { getFunctions } from 'firebase/functions';
// // --- Optional: Import emulator functions if using Firebase Emulator Suite ---
// // import { connectAuthEmulator } from 'firebase/auth';
// // import { connectFirestoreEmulator } from 'firebase/firestore';
// // import { connectStorageEmulator } from 'firebase/storage';
// // import { connectFunctionsEmulator } from 'firebase/functions';

// const firebaseConfig = {
//     // Your config details - **KEEP THESE SECURE**
//     // Consider using environment variables for sensitive keys like apiKey
//     apiKey: "AIzaSyBr-2R9wRZqU8irbCWc82O2tsKOz03zLxg", // Example - Replace with your actual key
//     authDomain: "my-agency-manager.firebaseapp.com",
//     projectId: "my-agency-manager",
//     storageBucket: "my-agency-manager.firebasestorage.app",
//     messagingSenderId: "753487447486",
//     appId: "1:753487447486:web:bf5d2eec65f1a17628e5ef"
//   };


// // Initialize Firebase App
// const app = initializeApp(firebaseConfig);

// // Initialize Firebase Services
// const db = getFirestore(app);
// const auth = getAuth(app);
// const storage = getStorage(app);

// // --- Initialize Firebase Functions ---
// // **IMPORTANT**: Replace 'your-function-region' with the actual region
// // where your functions are deployed (e.g., 'europe-west1', 'asia-northeast1').
// // If your functions are in 'us-central1', you can omit the region parameter:
// // const functions = getFunctions(app);
// const functionsRegion = 'us-central1'; // <-- CHANGE THIS if your functions are deployed elsewhere!
// const functions = getFunctions(app, functionsRegion);


// // --- Optional: Connect to Firebase Emulator Suite for Local Development ---
// // Uncomment the relevant connectEmulator lines below if you are running the emulators.
// // Make sure the ports match your firebase.json configuration.
// /*
// if (window.location.hostname === "localhost") {
//   console.log("Connecting to Firebase Emulators...");

//   // Point Auth to the emulator
//   // connectAuthEmulator(auth, "http://localhost:9099");

//   // Point Firestore to the emulator
//   // connectFirestoreEmulator(db, "localhost", 8080);

//   // Point Storage to the emulator
//   // connectStorageEmulator(storage, "localhost", 9199);

//   // Point Functions to the emulator
//   // connectFunctionsEmulator(functions, "localhost", 5001); // Default port is 5001
// }
// */
// // --- End Emulator Configuration ---


// // --- Export Firebase services ---
// // Make sure to export the 'functions' instance
// export { db, auth, storage, functions, app };

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// --- Agency Manager Config ---
const agencyConfig = {
  apiKey: "AIzaSyBr-2R9wRZqU8irbCWc82O2tsKOz03zLxg",
  authDomain: "my-agency-manager.firebaseapp.com",
  projectId: "my-agency-manager",
  storageBucket: "my-agency-manager.firebasestorage.app",
  messagingSenderId: "753487447486",
  appId: "1:753487447486:web:bf5d2eec65f1a17628e5ef"
};

// Initialize Agency App
const agencyApp = initializeApp(agencyConfig);
const db = getFirestore(agencyApp);
const auth = getAuth(agencyApp);
const storage = getStorage(agencyApp);
const agencyFunctions = getFunctions(agencyApp, 'us-central1');

// --- Accounting Project Config ---
const accountingConfig = {
  apiKey: "AIzaSyDbgQB7xR4QC5nrYqGVxC88f8avhwSUqOQ",
  authDomain: "accountant-grow-up.firebaseapp.com",
  projectId: "accountant-grow-up",
  storageBucket: "accountant-grow-up.appspot.com",
  messagingSenderId: "517690834966",
  appId: "1:517690834966:web:6f2e68d884da7e0bdd7537"
};

// Initialize Accounting App
const accountingApp = initializeApp(accountingConfig, 'accountingApp'); // Use unique name for second app
const accountingFunctions = getFunctions(accountingApp, 'us-central1');

// Export both sets (agencyApp is the default app — needed for Cloud Messaging)
export { db, auth, storage, agencyFunctions, accountingFunctions, agencyApp as app };
